// src/Login.js
import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    // CAPTCHA TEMPORARILY DISABLED
    setLoading(true);

    try {
      await login(email, password, null);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0f2419",
      padding: "20px"
    }}>
      <div style={{
        background: "#1a3327",
        padding: "40px",
        borderRadius: "12px",
        border: "1px solid #2d5a45",
        maxWidth: "440px",
        width: "100%"
      }}>
        <h1 style={{ color: "white", marginTop: 0 }}>Sign in</h1>
        <p style={{ color: "#888", marginBottom: "30px" }}>Welcome to AgroConnect</p>

        {error && (
          <div style={{
            background: "#fee2e2",
            color: "#991b1b",
            padding: "12px",
            borderRadius: "6px",
            marginBottom: "20px"
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", color: "#888", marginBottom: "8px" }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #2d5a45",
                background: "#0f2419",
                color: "white",
                fontSize: "16px"
              }}
            />
          </div>

          <div style={{ marginBottom: "30px" }}>
            <label style={{ display: "block", color: "#888", marginBottom: "8px" }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #2d5a45",
                background: "#0f2419",
                color: "white",
                fontSize: "16px"
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: loading ? "#888" : "#4ade80",
              color: "#0f2419",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <p style={{ color: "#888", marginTop: "20px", textAlign: "center" }}>
          Don't have an account?{" "}
          <Link to="/register" style={{ color: "#4ade80", textDecoration: "none" }}>
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}